/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Unavailabledescription1Inputs */

const id_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ini tidak dapat dimuat saat ini.`)
};

const ms_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil ini tidak dapat dimuatkan buat masa ini.`)
};

const da_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne profil kunne ikke indlæses lige nu.`)
};

const de_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil konnte momentan nicht geladen werden.`)
};

const en_us2_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile could not be loaded right now.`)
};

const es_es2_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar este perfil en este momento.`)
};

const es_mx2_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar este perfil en este momento.`)
};

const fil_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi ma-load ang profile na ito sa ngayon.`)
};

const fr_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce profil n'a pas pu être chargé pour le moment.`)
};

const it_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo profilo non può essere caricato al momento.`)
};

const hu_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a profil jelenleg nem tölthető be.`)
};

const nl_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit profiel kan op dit moment niet worden geladen.`)
};

const no_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne profilen kunne ikke lastes akkurat nå.`)
};

const pl_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten profil nie może być teraz załadowany.`)
};

const pt_br2_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil não pôde ser carregado no momento.`)
};

const pt_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil não pôde ser carregado de momento.`)
};

const ro_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acest profil nu a putut fi încărcat momentan.`)
};

const fi_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätä profiilia ei voitu ladata juuri nyt.`)
};

const sv_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna profil kunde inte laddas just nu.`)
};

const vi_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể tải hồ sơ này ngay bây giờ.`)
};

const tr_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu profil şu anda yüklenemedi.`)
};

const cs_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento profil nelze momentálně načíst.`)
};

const bg_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този профил не може да бъде зареден в момента.`)
};

const ru_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот профиль не удалось загрузить в данный момент.`)
};

const uk_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося завантажити цей профіль зараз.`)
};

const ar_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذر تحميل هذا الملف الشخصي الآن.`)
};

const hi_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह प्रोफ़ाइल अभी लोड नहीं की जा सकी।`)
};

const th_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถโหลดโปรไฟล์นี้ได้ในขณะนี้`)
};

const ja_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在このプロフィールを読み込めません。`)
};

const zh_cn2_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前无法加载此个人资料。`)
};

const zh_hant1_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前無法載入此個人資料。`)
};

const ko_profile_errors_unavailabledescription1 = /** @type {(inputs: Profile_Errors_Unavailabledescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 이 프로필을 불러올 수 없습니다.`)
};

/**
* | output |
* | --- |
* | "This profile could not be loaded right now." |
*
* @param {Profile_Errors_Unavailabledescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_unavailabledescription1 = /** @type {((inputs?: Profile_Errors_Unavailabledescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Unavailabledescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_unavailabledescription1(inputs)
	if (locale === "ms") return ms_profile_errors_unavailabledescription1(inputs)
	if (locale === "da") return da_profile_errors_unavailabledescription1(inputs)
	if (locale === "de") return de_profile_errors_unavailabledescription1(inputs)
	if (locale === "en-US") return en_us2_profile_errors_unavailabledescription1(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_unavailabledescription1(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_unavailabledescription1(inputs)
	if (locale === "fil") return fil_profile_errors_unavailabledescription1(inputs)
	if (locale === "fr") return fr_profile_errors_unavailabledescription1(inputs)
	if (locale === "it") return it_profile_errors_unavailabledescription1(inputs)
	if (locale === "hu") return hu_profile_errors_unavailabledescription1(inputs)
	if (locale === "nl") return nl_profile_errors_unavailabledescription1(inputs)
	if (locale === "no") return no_profile_errors_unavailabledescription1(inputs)
	if (locale === "pl") return pl_profile_errors_unavailabledescription1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_unavailabledescription1(inputs)
	if (locale === "pt") return pt_profile_errors_unavailabledescription1(inputs)
	if (locale === "ro") return ro_profile_errors_unavailabledescription1(inputs)
	if (locale === "fi") return fi_profile_errors_unavailabledescription1(inputs)
	if (locale === "sv") return sv_profile_errors_unavailabledescription1(inputs)
	if (locale === "vi") return vi_profile_errors_unavailabledescription1(inputs)
	if (locale === "tr") return tr_profile_errors_unavailabledescription1(inputs)
	if (locale === "cs") return cs_profile_errors_unavailabledescription1(inputs)
	if (locale === "bg") return bg_profile_errors_unavailabledescription1(inputs)
	if (locale === "ru") return ru_profile_errors_unavailabledescription1(inputs)
	if (locale === "uk") return uk_profile_errors_unavailabledescription1(inputs)
	if (locale === "ar") return ar_profile_errors_unavailabledescription1(inputs)
	if (locale === "hi") return hi_profile_errors_unavailabledescription1(inputs)
	if (locale === "th") return th_profile_errors_unavailabledescription1(inputs)
	if (locale === "ja") return ja_profile_errors_unavailabledescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_unavailabledescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_unavailabledescription1(inputs)
	return ko_profile_errors_unavailabledescription1(inputs)
});
export { profile_errors_unavailabledescription1 as "profile.errors.unavailableDescription" }